import {Component, ElementRef, Injector, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {destroy$} from './components/destroyable';
import {RouteLoadingIndicatorService} from './components/loading-indicator';
import {OnboardingUpdatesPingService} from './components/onboarding-updates-ping';
import {AppConfigService} from './services/config.service';
import {ContextMenuService} from './services/context-menu-service';

/**
 * App Component
 * Top Level Component
 */
@Component({
    selector: 'app',
    styleUrls: ['./app.component.scss'],
    templateUrl: './app.component.html',
    viewProviders: [
        // [DC-150] Periodically update current Onboarding status on client UI.
        OnboardingUpdatesPingService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    public readonly destroy$ = destroy$();

    public readonly isBackoffice = this.appConfigService.isBoEnv();

    constructor(
        private elementRef: ElementRef,
        private contextMenuService: ContextMenuService,
        private routeLoadingIndicatorService: RouteLoadingIndicatorService,
        private appConfigService: AppConfigService,
        private injector: Injector
    ) {}

    public ngOnInit(): void {
        this.enableContextMenu = this.contextMenuService.disableContextMenu(this.elementRef);
        this.routeLoadingIndicatorService.listenToRouteLoading();

        // [DC-150] Periodically update current Onboarding status on client UI.
        this.injector.get(OnboardingUpdatesPingService);
    }

    public ngOnDestroy(): void {
        this.enableContextMenu();
    }

    private enableContextMenu: () => void = () => undefined;

}
